module.exports = __webpack_public_path__ + "img/ic_generate_token.23bff343.svg";